import {Button} from '@material-ui/core';
import {ArrowBack} from '@material-ui/icons';
import AccountRouteConstants from 'Agent/Accounts/AccountRouteConstants';
import {useBreadcrumbs} from 'Core/hooks/useBreadcrumbs';
import {fromAsync, fromResult, toPage} from 'Core/models/Async';
import * as O from 'fp-ts/lib/Option';
import {pipe} from 'fp-ts/lib/pipeable';
import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {RouteComponentProps} from 'react-router';
import {ReducerState} from 'rootReducer';
import Column from 'Shared/components/PagedView/Column';
import PagedView from 'Shared/components/PagedView/PagedView';
import {hasEisFlag} from 'Shared/utilities/DataSourceUtility';
import {toFormattedDateAsUTC} from 'Shared/utilities/DateFormatter';
import {toMoneyValue} from 'Shared/utilities/FormatMoney';
import {NoOp} from 'Shared/utilities/IOUtilities';

type AccountDiscrepanciesProps = RouteComponentProps<{
  accountId: string;
  accountNumber: string;
  sourceId: string;
  paymentDate: string;
}>;

const AccountDiscrepancies = (props: AccountDiscrepanciesProps) => {
  const {history, match} = props;
  const {accountDetails, discrepancies} = useSelector((state: ReducerState) => state.accountDetails);
  const {accountId, accountNumber} = match.params;

  useBreadcrumbs(accountNumber, '/agent/accounts/' + accountId + '/accountNumber/' + accountNumber);

  useEffect(() => {
    if (O.isNone(discrepancies)) {
      history.push(
        AccountRouteConstants.ACCOUNT_DETAILS(
          match.params.accountId,
          match.params.accountNumber,
          hasEisFlag(fromAsync(accountDetails))
        )
      );
    }
  }, []);

  return pipe(
    discrepancies,
    O.fold(
      () => <>No Discrepancies</>,
      discrepancySummaries => (
        <>
          <PagedView
            pagedViewKey="accountDiscrepancies"
            loadMore={NoOp}
            data={fromResult(toPage(discrepancySummaries))}
            actions={
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  history.goBack();
                }}
              >
                <ArrowBack /> Return to Summary
              </Button>
            }
          >
            {columnProps => (
              <>
                <Column {...columnProps} title="Policy Number" default ddprivacy="mask">
                  {discrepancy => discrepancy.policyNumber}
                </Column>
                <Column {...columnProps} title="Insured Name" default ddprivacy="mask">
                  {discrepancy => discrepancy.insuredName}
                </Column>
                <Column {...columnProps} title="Bill Amount" default>
                  {discrepancy => toMoneyValue(discrepancy.billAmount)}
                </Column>
                <Column {...columnProps} title="Paid Amount" default>
                  {discrepancy => toMoneyValue(discrepancy.paidAmount)}
                </Column>
                <Column {...columnProps} title="Discrepancy Amount" default>
                  {discrepancy => toMoneyValue(discrepancy.discrepancyAmount)}
                </Column>
                <Column {...columnProps} title="Issue Date" default>
                  {discrepancy => toFormattedDateAsUTC(discrepancy.issueDate)}
                </Column>
                <Column {...columnProps} title="Policy Type" default>
                  {discrepancy => discrepancy.policyType}
                </Column>
                <Column {...columnProps} title="Status" default>
                  {discrepancy => discrepancy.status}
                </Column>
              </>
            )}
          </PagedView>
        </>
      )
    )
  );
};

export default AccountDiscrepancies;
